var _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgM12 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "M12 Logo",
  viewBox: "0 0 109.22 39.514"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32308"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32307"
}, /*#__PURE__*/React.createElement("rect", {
  width: 103.306,
  height: 39.514,
  fill: "#fff",
  "data-name": "Rectangle 25681",
  rx: 5,
  transform: "translate(.001 -.001)"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d00021",
  d: "M6.792 7.297h13.914l4.1 14.544h.072l4.1-14.544h13.914v25.025h-8.973V14.445h-.07l-5.257 17.876h-7.5l-5.257-17.876h-.071v17.876H6.793Z",
  "data-name": "Path 4969"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32310"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32309"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#161615",
  d: "M53.227 17.965h-7.66l1.338-6.286h1.516c4.444-.074 6.971-1.047 8.959-4.516h7.619l-5.348 25.071h-9.464Z",
  "data-name": "Path 4970"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#161615",
  d: "M84.499 16.887a2.59 2.59 0 0 0 2.329-1.936c.322-1.433-1.325-2.006-3.655-2.006-2.723 0-5.521.25-6.487 3.476H65.935c2.582-8.566 11.006-9.712 17.348-9.712 8.175 0 15.559 1.433 14.089 8.388-1 4.732-6.309 6.629-10.037 7.314l-9.355 1.683c-2.222.4-3.478.968-4.3 1.9h20.819l-1.325 6.236H61.705c2.224-9.57 8.891-12.475 15.127-13.764Z",
  "data-name": "Path 4971"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M105.174 37.412h-.709v-.436h1.937v.436h-.709v1.927h-.519Z",
  "data-name": "Path 4972"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M106.676 36.975h.732l.553 1.625h.006l.522-1.625h.732v2.363h-.486v-1.675h-.006l-.58 1.675h-.4l-.579-1.659h-.006v1.659h-.487Z",
  "data-name": "Path 4973"
})))));
export default SvgM12;